module.exports = __webpack_public_path__ + "img/logo2.6aaa044f.svg";